const trains = {
  train: "Kereta", // translated 
  trains: "Kereta api", // translated 
  fairConditions: "Kondisi Adil", // translated 
  to: "ke", // translated 
  earlier: "Lebih awal", // translated 
  later: "Nanti", // translated 
  adults: "Dewasa", // translated 
  child: "Anak", // translated 
  senior: "Senior", // translated 
  seniors: "Senior", // translated 
  price: "Harga", // translated 
  for: "untuk", // translated 
  total: "Total", // translated 
  selected: "Terpilih", // translated 
  prebook: "Pesan terlebih dahulu", // translated 
  book: "Buku", // translated 
  payment: "Pembayaran", // translated 
  return: "Kembali", // translated 
  passengers: "Penumpang", // translated 
  delivery: "Pengiriman", // translated 
  summary: "Ringkasan", // translated 
  checkout: "Periksa", // translated 
  trainToastCorrectFillForm: "Silakan isi semua kolom dengan benar.", // translated 
  fareConditions: "Ketentuan tarif", // translated 
  travelInfo: "Informasi perjalanan", // translated 
  remarks: "Komentar pelanggan", // translated 
  noServices: "Tidak ada layanan", // translated 
  timesAndSeats: "Waktu dan kursi", // translated 
  mobileTicket: "Tiket seluler", // translated 
  stationTicket: "Kumpulkan di stasiun", // translated 
  homeTicket: "Cetak di rumah", // translated 
  countryCode: "Kode negara", // translated 
  chooseTicket: "Pilih metode pengiriman tiket", // translated 
  ticketError: "Silakan pilih tiket untuk semua tujuan", // translated 
  ticketDelivery: "Silakan pilih metode pengiriman tiket", // translated 
  passengerDetails: "Detail penumpang", // translated 
  waitWhileProcessingPayment:
    "Harap tunggu sementara kami memproses pembayaran Anda, jangan segarkan atau tutup halaman.", // translated 
  reductionCardId: "ID kartu pengurangan", // translated 
  countryOfResidence: "Negara tempat tinggal", // translated 
  countryOfBirth: "Negara tempat lahir", // translated 
  documentCountry: "Negara dokumen", // translated 
  documentNumber: "Nomor dokumen", // translated 
  expirationDate: "Tanggal habis tempo", // translated 
  documentType: "Tipe dokumen", // translated 
  travelerDocumentInfo: "Info dokumen wisatawan", // translated 
  youth: "Anak muda", // translated 
  youths: "Pemuda", // translated 
  departTimeEarlyFirst: "Waktu keberangkatan (paling awal terlebih dahulu)", // translated 
};



export default trains;
